export type AccountRoleType = 'member' | 'owner' | 'portal_user'

export const BuiltInAccountRoleNames: { [key in Uppercase<AccountRoleType>]: AccountRoleType } = {
    MEMBER: 'member',
    OWNER: 'owner',
    PORTAL_USER: 'portal_user',
}
